module.exports = __webpack_public_path__ + "static/img/三角顶.4013072.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/三角顶.png
// module id = gCMr
// module chunks = 0